import PersonBubble from '../../src/legacy/PersonBubble.tsx';
export default PersonBubble;
